import type { settings as en } from '@/i18n/locales/en/settings';
import type { Translation } from '@/i18n/types';

export const settings: Translation<typeof en> = {
  title: 'Paramètres',
  lead: 'Le profil de votre entreprise, son identité visuelle et ses paramètres de confidentialité.',
  noCompany: 'Aucune entreprise active sélectionnée.',
  adminOnly:
    'Seul un administrateur de la plateforme peut modifier ceci — vous voyez les valeurs actuelles.',
  save: 'Enregistrer',
  nav: {
    label: 'Menu des paramètres',
    profile: 'Profil',
    branding: 'Identité visuelle',
    privacy: 'Confidentialité',
    modules: 'Modules',
  },
  profile: {
    title: 'Profil',
    name: "Nom de l'organisation",
    industry: 'Secteur d’activité',
    industryHint: 'Texte libre, ex. « Logistique » ou « Santé ».',
    employeeCount: "Nombre d'employés",
    plan: 'Abonnement',
    planPlaceholder: "Voir l'abonnement",
  },
  branding: {
    title: 'Identité visuelle',
    lead: 'Votre logo et votre couleur d’accent, tels qu’ils apparaissent dans un aperçu en direct.',
    logo: 'Téléverser le logo',
    logoHint: 'Téléversé immédiatement ; ou saisissez une URL existante ci-dessous.',
    logoUrl: 'URL du logo',
    upload: {
      uploading: 'Téléversement en cours…',
      tooLarge: 'Le fichier est trop volumineux (max. 10 Mo).',
      invalidType: 'Type de fichier non autorisé.',
    },
    accentColor: 'Couleur d’accent',
    preview: 'Aperçu en direct',
    colors: {
      mint: 'Menthe',
      pine: 'Vert sapin',
      ink: 'Noir',
      amber: 'Ambre',
      coral: 'Corail',
      sky: 'Bleu ciel',
    },
  },
  privacy: {
    title: 'Confidentialité',
    lead: 'La taille de groupe minimale pour les statistiques agrégées, et ce que votre entreprise partage.',
    minGroupSize: 'Taille de groupe minimale (k-anonymat)',
    minGroupSizeHint:
      'En dessous de ce seuil, un groupe est trop petit pour afficher des statistiques agrégées.',
    minGroupSizeValue: '{{count}} personnes',
    effective: 'Actuellement en vigueur : {{count}} personnes',
    aggregatedData: 'Données agrégées',
    aggregatedDataHint:
      'Afficher les statistiques agrégées pour les groupes atteignant la taille minimale.',
    explicitConsent: 'Consentement explicite requis',
    explicitConsentHint:
      'Exiger une réponse de consentement individuelle plutôt qu’un consentement collectif.',
    dataExport: 'Export de données',
    dataExportHint: "Autoriser l'export des données statistiques.",
    auditLogHint: 'Les actions administratives sont toujours consignées dans un journal d’audit.',
  },
  modules: {
    title: 'Modules',
    lead: 'Activez ou désactivez les modules disponibles pour votre entreprise.',
    vitality: 'Vitalité',
    vitalityHint: "Suivi du sommeil, du stress, de la fréquence cardiaque et de l'activité.",
    participation: 'Participation',
    participationHint: "Entonnoir d'engagement et métriques de participation.",
    pilots: 'Projets pilotes',
    pilotsHint: 'Lancez et suivez les programmes pilotes.',
    challenges: 'Défis',
    challengesHint: 'Créez et gérez les défis de bien-être.',
    communication: 'Communication',
    communicationHint: 'Envoyez des notifications et des messages aux employés.',
    documents: 'Documents',
    documentsHint: "Publiez et gérez les documents de l'entreprise.",
    reports: 'Rapports',
    reportsHint: "Générez et exportez les rapports d'analyse.",
    ai_coach: 'Coach IA',
    ai_coachHint: 'Coaching personnalisé par intelligence artificielle.',
  },
};
